var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSupport = function SvgSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m9.112 11.863-5.019-5.02a1 1 0 0 1 .26-1.6l1.03-.516-.807-3.63L1 1.89c.45 4.09 1.725 7.17 3.81 9.255 2.086 2.086 5.165 3.36 9.256 3.811l.795-3.578-3.631-.806-.515 1.03a1 1 0 0 1-1.602.26Zm.707-.707.515-1.03a1 1 0 0 1 1.112-.53l3.63.807a1 1 0 0 1 .76 1.193l-.795 3.575a1 1 0 0 1-1.081.778 25.12 25.12 0 0 1-.487-.055c-4.065-.521-7.194-1.864-9.37-4.04C1.885 9.634.533 6.428.033 2.25l-.028-.255A1 1 0 0 1 .783.915L4.36.12a1 1 0 0 1 1.193.76l.806 3.63a1 1 0 0 1-.528 1.112l-1.03.515 5.018 5.019Z",
    fill: "#000624"
  })));
};
export default SvgSupport;